import { render, staticRenderFns } from "./BInputGroupFormDatepicker.vue?vue&type=template&id=d8572c76&"
import script from "./BInputGroupFormDatepicker.vue?vue&type=script&lang=js&"
export * from "./BInputGroupFormDatepicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports